export const portfolio = [
    {
      name: "Javascript",
      category: ["frontend","all"]
    },
    {
      name: "React",
      category: ["frontend","all"]
    },
    {
      name: "html",
      category: ["frontend","all"]
    },
    {
      name: "css",
      category: ["frontend","all"]
    },
    {
      name: "bootstrap",
      category: ["frontend","all"]
    },
    {
        name: "Node.js",
        category: ["all","backend"]
    },
    {
        name: "express.js",
        category: ["all","backend"]
    },
    {
        name: "MySQL",
        category: ["all", "others"]
    },
    {
        name: "Photoshop",
        category: ["all", "software"]
    },
    {
        name: "Linux",
        category: ["all", "others"]
    }
  ];

 